import { useMemo } from 'react';
import { PosMultiSelect } from 'src/core/POS/PosMultiSelect';
import { useConsigneeAccountInfo } from 'src/hooks/api/useConsigneeAccountInfo';

import { ConsigneeFilterMultiSelectorProps } from './ConsigneeFilterMultiSelector.types';

export const ConsigneeFilterMultiSelector = ({
  values,
  onChange,
  ...rest
}: ConsigneeFilterMultiSelectorProps) => {
  const { data: consigneeAccounts, isLoading } = useConsigneeAccountInfo();

  const consigneeOptions = useMemo(
    () =>
      Object.fromEntries(
        (consigneeAccounts ?? []).map((account) => [
          account.id,
          account.accountName,
        ])
      ),
    [consigneeAccounts]
  );

  return (
    <PosMultiSelect
      {...rest}
      searchable
      loading={isLoading}
      values={values}
      onChange={onChange}
      valueOptionsContent={consigneeOptions}
    />
  );
};
